{
  "navigation": {
    "modules": {
      "home": "Home",
      "buying": "Buying",
      "decisions": "Decisions",
      "procurement": "Procurement",
      "suppliers": "Suppliers",
      "administration": "Administration",
      "masterData": "Master data",
      "reports": "Reports"
    },
    "workAreas": "Work areas",
    "allWorkAreas": "All work areas",
    "moduleNavigation": "{{module}} navigation",
    "openModule": "Browse {{module}}",
    "reportLoading": "Loading available reports…",
    "reportError": "Available reports could not be loaded.",
    "cartLines": "{{count}} cart lines"
  }
}
